import styled from '@emotion/styled';
import React from 'react';

const Svg = styled.svg<{ active?: boolean; hover?: boolean }>`
  & path {
    fill: transparent;
    ${({ active }) => active && 'fill: #cee1ea;'};
  }

  & rect,
  & line {
    stroke: #bbc4cd;
    ${({ active, hover }) => (active || hover) && 'stroke: #20446a'};
  }

  &:hover path {
    fill: #cee1ea;
  }
`;

export function Datepicker({
  active,
  hover,
}: {
  active?: boolean;
  hover?: boolean;
}) {
  return (
    <Svg
      width="28px"
      height="26px"
      viewBox="0 0 28 26"
      version="1.1"
      active={active}
      hover={hover}
    >
      <g
        id="Gengi"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Artboard" transform="translate(-144.000000, -71.000000)">
          <g id="Group" transform="translate(145.000000, 72.000000)">
            <path
              d="M2.18181818,2.18181818 L24,2.18181818 C25.2049849,2.18181818 26.1818182,3.15865145 26.1818182,4.36363636 L26.1818182,9.45454545 L26.1818182,9.45454545 L0,9.45454545 L0,4.36363636 C-1.47568091e-16,3.15865145 0.976833273,2.18181818 2.18181818,2.18181818 Z"
              id="Rectangle-Copy-16"
            ></path>
            <rect
              id="Rectangle-Copy-17"
              stroke="#20446A"
              strokeLinejoin="round"
              x="0"
              y="2.18181818"
              width="26.1818182"
              height="21.8181818"
              rx="2.18181818"
            ></rect>
            <line
              x1="6.90909091"
              y1="0.363636364"
              x2="6.90909091"
              y2="4"
              id="Line-7-Copy-4"
              stroke="#20446A"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <line
              x1="19.2727273"
              y1="0.363636364"
              x2="19.2727273"
              y2="4"
              id="Line-7-Copy-5"
              stroke="#20446A"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <line
              x1="0.622314453"
              y1="9.5"
              x2="25.5"
              y2="9.5"
              id="Line-Copy"
              stroke="#20446A"
              strokeLinecap="square"
            ></line>
          </g>
        </g>
      </g>
    </Svg>
  );
}
